import PropTypes from 'prop-types'
import React, { useState } from 'react'
import AccordionItem from './AccordionItem'
import { addHyperlinkTitle } from '../../../../common/helpers'
import classNames from 'classnames'

const Accordion = ({
  items,
  title,
  titleCenter,
  questionClassName,
  answerClassName,
  titleClassName,
  showFirstDivider,
}) => {
  const [marked, setMarked] = useState(undefined)
  const handleChangeCollapse = (id) => {
    if (id === marked) {
      setMarked(undefined)
    } else {
      setMarked(id)
    }
  }

  const count = Array.isArray(items) ? items.length : 0
  if (!(count > 2)) return null

  return (
    <>
      <div className="m-auto max-w-full px-5 lg:max-w-906 lg:px-2">
        {title ? (
          <h2
            data-testid="faq title"
            className={classNames(
              'leading-10 text-black-base',
              titleCenter && 'text-center',
              titleClassName
            )}
          >
            {title}
          </h2>
        ) : null}
        <div data-testid="itemList" className="mb-8 border-b border-gray-540">
          {items.map((f, i) => {
            const { title: question, content } = f

            addHyperlinkTitle(content?.content, question)

            return (
              <AccordionItem
                title={question}
                content={content}
                key={i}
                id={i}
                opened={marked === i}
                changeCollapse={handleChangeCollapse}
                questionClassName={questionClassName}
                answerClassName={answerClassName}
                showFirstDivider={showFirstDivider}
              />
            )
          })}
        </div>
      </div>
    </>
  )
}

Accordion.defaultProps = {
  items: [],
  titleCenter: false,
  titleClassName:
    'my-5.4 lg:my-8 text-1.5xl lg:text-3.5xl lg:leading-primary-xs lg:text-gray-910',
}
Accordion.propTypes = {
  items: PropTypes.array,
  title: PropTypes.string,
  titleCenter: PropTypes.bool,
  questionClassName: PropTypes.string,
  answerClassName: PropTypes.string,
  titleClassName: PropTypes.string,
  showFirstDivider: PropTypes.bool,
}

export default Accordion
